export const FETCH_UPCOMING_SESSIONS_REQUEST = "FETCH_UPCOMING_SESSIONS_REQUEST";
export const FETCH_UPCOMING_SESSIONS_SUCCESS = "FETCH_UPCOMING_SESSIONS_SUCCESS";
export const FETCH_UPCOMING_SESSIONS_FAILURE = "FETCH_UPCOMING_SESSIONS_FAILURE";
export const RESET_UPCOMING_SESSIONS             = "RESET_UPCOMING_SESSIONS"

